import { PageHeader } from '@/components/layout/PageHeader';
import { DoctorDownloadScreen } from '@/components/features/download/DoctorDownloadScreen';
import { DownloadQueryProvider } from '@/contexts/DownloadQueryContext';

export function DoctorDownloadRaw() {
  return (
    <DownloadQueryProvider restrictUnavailableActivities={false}>
      <div>
        <PageHeader
          title="Download Raw Activities"
          description="Select patients and filter activities to download raw data in bulk"
        />

        <DoctorDownloadScreen mode="raw" />
      </div>
    </DownloadQueryProvider>
  );
}
